<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <h1 class="title">Groups Supply</h1>
      <app-cells><h2 class="title">Start</h2></app-cells>
      <v-client-table
        :data="table_start.items"
        :columns="table_start.columns"
        :options="table_start.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #h__starting_point><div class="table-default__left">Starting point</div></template>
        <template #h__type><div class="table-default__left">Type</div></template>
        <template #h__route><div class="table-default__left">Route</div></template>
        <template #h__chief_guide><div class="table-default__left">Guide</div></template>
        <template #h__chain><div class="table-default__left">Chain</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'climbing-groups-supply-detail-general', params: { id: row.id } }"
              class="table-default__link-border table-default__link-border--inline"
            >
              {{ row.name }}
            </router-link> ({{ row.pax }})
          </div>
        </template>
        <template #starting_point="{ row }">
          <div class="table-default__controls table-default__left">
              <span v-if="row.starting_point">
                <span v-if="row.starting_point.place_id !== 'ChIJqQRrDoleNxgRANW_07pTSXY'" class="status-tag" :style="{ 'backgroundColor': '#439ad1' }">{{ row.starting_point.short_name }}</span>
                <span v-else>{{ row.starting_point.short_name }}</span>
              </span>
            <span v-else>-</span>
          </div>
        </template>
        <template #type="{ row }">
          <div class="table-default__left">
              <span class="status-tag" :style="{ 'backgroundColor': row.type.color || '#8a8a8a' }">
                {{ row.type ? row.type.name : '-' }}
              </span>
          </div>
        </template>
        <template #route="{ row }">
          <div class="table-default__left">{{ row.route.name }} {{ row.route.duration }}</div>
        </template>
        <template #chief_guide="{ row }">
          <div class="table-default__left">
            {{ row.chief_guide ? row.chief_guide.full_name : '-' }}
          </div>
        </template>
        <template #tour_start="{ row }">{{ dateFormat(row.tour_start) }}</template>
        <template #resupply="{ row }">{{ dateFormat(row.resupply) }}</template>
        <template #tour_end="{ row }">{{ dateFormat(row.tour_end) }}</template>
        <template #duration="{ row }">
            <span v-if="row.duration" class="status-tag" :style="{ backgroundColor: '#424242' }">
              {{ row.duration }}
            </span>
          <span v-else>-</span>
        </template>
        <template #chain="{ row }">
          <div class="table-default__left">
            {{ row.chain ? `${row.chain.chain.name} #${row.chain.sort}` : '-' }}
          </div>
        </template>
      </v-client-table>
      <app-cells><h2 class="title">Resupply</h2></app-cells>
      <v-client-table
        :data="table_resupply.items"
        :columns="table_resupply.columns"
        :options="table_resupply.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #h__starting_point><div class="table-default__left">Starting point</div></template>
        <template #h__type><div class="table-default__left">Type</div></template>
        <template #h__route><div class="table-default__left">Route</div></template>
        <template #h__chief_guide><div class="table-default__left">Guide</div></template>
        <template #h__chain><div class="table-default__left">Chain</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'climbing-groups-supply-detail-general', params: { id: row.id } }"
              class="table-default__link-border table-default__link-border--inline"
            >
              {{ row.name }}
            </router-link> ({{ row.pax }})
          </div>
        </template>
        <template #starting_point="{ row }">
          <div class="table-default__controls table-default__left">
              <span v-if="row.starting_point">
                <span v-if="row.starting_point.place_id !== 'ChIJqQRrDoleNxgRANW_07pTSXY'" class="status-tag" :style="{ 'backgroundColor': '#439ad1' }">{{ row.starting_point.short_name }}</span>
                <span v-else>{{ row.starting_point.short_name }}</span>
              </span>
            <span v-else>-</span>
          </div>
        </template>
        <template #type="{ row }">
          <div class="table-default__left">
              <span class="status-tag" :style="{ 'backgroundColor': row.type.color || '#8a8a8a' }">
                {{ row.type ? row.type.name : '-' }}
              </span>
          </div>
        </template>
        <template #route="{ row }">
          <div class="table-default__left">{{ row.route.name }} {{ row.route.duration }}</div>
        </template>
        <template #chief_guide="{ row }">
          <div class="table-default__left">
            {{ row.chief_guide ? row.chief_guide.full_name : '-' }}
          </div>
        </template>
        <template #tour_start="{ row }">{{ dateFormat(row.tour_start) }}</template>
        <template #resupply="{ row }">{{ dateFormat(row.resupply) }}</template>
        <template #tour_end="{ row }">{{ dateFormat(row.tour_end) }}</template>
        <template #duration="{ row }">
            <span v-if="row.duration" class="status-tag" :style="{ backgroundColor: '#424242' }">
              {{ row.duration }}
            </span>
          <span v-else>-</span>
        </template>
        <template #chain="{ row }">
          <div class="table-default__left">
            {{ row.chain ? `${row.chain.chain.name} #${row.chain.sort}` : '-' }}
          </div>
        </template>
      </v-client-table>
      <app-cells><h2 class="title">Finish</h2></app-cells>
      <v-client-table
        :data="table_finish.items"
        :columns="table_finish.columns"
        :options="table_finish.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #h__starting_point><div class="table-default__left">Starting point</div></template>
        <template #h__type><div class="table-default__left">Type</div></template>
        <template #h__route><div class="table-default__left">Route</div></template>
        <template #h__chief_guide><div class="table-default__left">Guide</div></template>
        <template #h__chain><div class="table-default__left">Chain</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link
              :to="{ name: 'climbing-groups-supply-detail-general', params: { id: row.id } }"
              class="table-default__link-border table-default__link-border--inline"
            >
              {{ row.name }}
            </router-link> ({{ row.pax }})
          </div>
        </template>
        <template #starting_point="{ row }">
          <div class="table-default__controls table-default__left">
              <span v-if="row.starting_point">
                <span v-if="row.starting_point.place_id !== 'ChIJqQRrDoleNxgRANW_07pTSXY'" class="status-tag" :style="{ 'backgroundColor': '#439ad1' }">{{ row.starting_point.short_name }}</span>
                <span v-else>{{ row.starting_point.short_name }}</span>
              </span>
            <span v-else>-</span>
          </div>
        </template>
        <template #type="{ row }">
          <div class="table-default__left">
              <span class="status-tag" :style="{ 'backgroundColor': row.type.color || '#8a8a8a' }">
                {{ row.type ? row.type.name : '-' }}
              </span>
          </div>
        </template>
        <template #route="{ row }">
          <div class="table-default__left">{{ row.route.name }} {{ row.route.duration }}</div>
        </template>
        <template #chief_guide="{ row }">
          <div class="table-default__left">
            {{ row.chief_guide ? row.chief_guide.full_name : '-' }}
          </div>
        </template>
        <template #tour_start="{ row }">{{ dateFormat(row.tour_start) }}</template>
        <template #resupply="{ row }">{{ dateFormat(row.resupply) }}</template>
        <template #tour_end="{ row }">{{ dateFormat(row.tour_end) }}</template>
        <template #duration="{ row }">
            <span v-if="row.duration" class="status-tag" :style="{ backgroundColor: '#424242' }">
              {{ row.duration }}
            </span>
          <span v-else>-</span>
        </template>
        <template #chain="{ row }">
          <div class="table-default__left">
            {{ row.chain ? `${row.chain.chain.name} #${row.chain.sort}` : '-' }}
          </div>
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { getClimbingGroupsSupply } from '@/http'
import { format, parseISO } from 'date-fns'

export default {
  name: 'ClimbingGroupsSupplyList',
  data() {
    return {
      page_loaded: false,
      table_start: {
        items: [],
        columns: ['name', 'starting_point', 'type', 'route', 'chief_guide', 'tour_start', 'resupply', 'tour_end', 'duration', 'chain'],
        options: {
          headings: {
            'name': 'Name',
            'start': 'Starting point',
            'type': 'Type',
            'route': 'Route',
            'chief_guide': 'Guide',
            'tour_start': 'Tour start',
            'resupply': 'Resupply',
            'tour_end': 'Tour end',
            'duration': 'Duration',
            'chain': 'Chain',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_resupply: {
        items: [],
        columns: ['name', 'starting_point', 'type', 'route', 'chief_guide', 'tour_start', 'resupply', 'tour_end', 'duration', 'chain'],
        options: {
          headings: {
            'name': 'Name',
            'start': 'Starting point',
            'type': 'Type',
            'route': 'Route',
            'chief_guide': 'Guide',
            'tour_start': 'Tour start',
            'resupply': 'Resupply',
            'tour_end': 'Tour end',
            'duration': 'Duration',
            'chain': 'Chain',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_finish: {
        items: [],
        columns: ['name', 'starting_point', 'type', 'route', 'chief_guide', 'tour_start', 'resupply', 'tour_end', 'duration', 'chain'],
        options: {
          headings: {
            'name': 'Name',
            'start': 'Starting point',
            'type': 'Type',
            'route': 'Route',
            'chief_guide': 'Guide',
            'tour_start': 'Tour start',
            'resupply': 'Resupply',
            'tour_end': 'Tour end',
            'duration': 'Duration',
            'chain': 'Chain',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    Promise.all([this.fetchItemsStart(), this.fetchItemsResupply(), this.fetchItemsFinish()])
      .then(() => { this.page_loaded = true })
  },
  methods: {
    async fetchItemsStart() {
      const response = await getClimbingGroupsSupply({category: 'start'})
      this.table_start.items = response.data
    },
    async fetchItemsResupply() {
      const response = await getClimbingGroupsSupply({category: 'resupply'})
      this.table_resupply.options.perPage = response.data.length
      this.table_resupply.items = response.data
    },
    async fetchItemsFinish() {
      const response = await getClimbingGroupsSupply({category: 'finish'})
      this.table_finish.items = response.data
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
  }
}
</script>